import { ReactNode, JSX } from 'react';
import { DOMNode, Element } from 'html-react-parser';

export type RichTextComponent = (element: DOMNode, children: ReactNode) => JSX.Element | null;

export const isElement = (node: DOMNode): node is Element =>
  typeof (node as Element).name !== 'undefined';
